<dx-chart
    #trendingChart
    id="trendingChart"
    [dataSource]="trendingData"
    [rotated]="false"
    [zoomAndPan]="{ argumentAxis: 'pan' }"
>
    <dxi-series
        argumentField="day"
        valueField="val"
        type="bar"
        color="#87ceeb"
        [barWidth]="50"
        [barPadding]="15"
    >
    </dxi-series>
    <dxi-value-axis [visible]="true" [title]="formatMode === 'decimal' ? 'Total Count' : 'Percent %'" [tickInterval]="formatMode === 'decimal' ? 1 : undefined">
        <dxo-label [format]="formatMode"></dxo-label>
    </dxi-value-axis>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-argument-axis
        [type]="'continuous'"
        argumentType="datetime"
        [wholeRange]="bounds"
        [(visualRange)]="currentVisualRange"
        [tickInterval]="tickInterval"
    >
        <dxo-label [visible]="true"></dxo-label>
        <dxo-grid [visible]="false"></dxo-grid>
        <dxo-tick [visible]="false"></dxo-tick>
    </dxo-argument-axis>
</dx-chart>
